(function () {
  'use strict';

  if (window.__elluxuryCartTimerLoaded) return;
  window.__elluxuryCartTimerLoaded = true;

  const TIMER_DURATION_SECONDS = 10 * 60;
  const STORAGE_KEY = 'elluxury_cart_timer_end';
  const TIMER_ID = 'elluxury-snap-cart-timer';
  const STYLE_ID = 'elluxury-snap-cart-timer-styles';

  let timerEnd = null;
  let previousItemCount = null;
  let cartRequestRunning = false;

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      #${TIMER_ID} {
        position: relative;
        width: 100%;
        margin: 0 0 10px;
        padding: 10px 12px;
        overflow: hidden;
        border: 1px solid rgba(212, 175, 55, 0.68);
        border-radius: 10px;
        background:
          radial-gradient(
            circle at 50% 0%,
            rgba(212, 175, 55, 0.11),
            transparent 65%
          ),
          #000000;
        color: #ffffff;
        box-sizing: border-box;
        box-shadow:
          0 0 10px rgba(212, 175, 55, 0.10),
          inset 0 0 14px rgba(212, 175, 55, 0.03);
      }

      #${TIMER_ID}::before {
        position: absolute;
        top: 0;
        right: 20%;
        left: 20%;
        height: 1px;
        background: linear-gradient(
          90deg,
          transparent,
          #f1d478,
          transparent
        );
        content: "";
      }

      #${TIMER_ID} .elluxury-timer-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        width: 100%;
      }

      #${TIMER_ID} .elluxury-timer-label {
        color: #ffffff !important;
        font-size: 13px;
        font-weight: 800;
        line-height: 1.3;
        text-align: center;
      }

      #${TIMER_ID} .elluxury-timer-time {
        display: inline-flex;
        min-width: 68px;
        align-items: center;
        justify-content: center;
        padding: 6px 9px;
        border: 1px solid rgba(212, 175, 55, 0.62);
        border-radius: 8px;
        background: rgba(212, 175, 55, 0.10);
        color: #d4af37;
        font-size: 18px;
        font-weight: 950;
        letter-spacing: 0.05em;
        line-height: 1;
        box-shadow: 0 0 8px rgba(212, 175, 55, 0.10);
        transition:
          color 0.25s ease,
          border-color 0.25s ease,
          background 0.25s ease,
          box-shadow 0.25s ease,
          transform 0.25s ease;
      }

      #${TIMER_ID} .elluxury-timer-time.is-urgent {
        border-color: rgba(239, 68, 68, 0.72);
        background: rgba(239, 68, 68, 0.10);
        color: #ff4545;
        box-shadow: 0 0 10px rgba(239, 68, 68, 0.18);
      }

      #${TIMER_ID} .elluxury-timer-time.is-critical {
        animation: elluxuryTimerPulse 1s ease-in-out infinite;
      }

      @keyframes elluxuryTimerPulse {
        0%,
        100% {
          transform: scale(1);
          box-shadow: 0 0 8px rgba(239, 68, 68, 0.15);
        }

        50% {
          transform: scale(1.035);
          box-shadow: 0 0 15px rgba(239, 68, 68, 0.30);
        }
      }

      @media screen and (max-width: 749px) {
        #${TIMER_ID} {
          margin-bottom: 8px;
          padding: 9px 10px;
          border-radius: 8px;
        }

        #${TIMER_ID} .elluxury-timer-row {
          gap: 7px;
        }

        #${TIMER_ID} .elluxury-timer-label {
          font-size: 11.5px;
        }

        #${TIMER_ID} .elluxury-timer-time {
          min-width: 62px;
          padding: 5px 7px;
          font-size: 16px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getStoredTimerEnd() {
    const storedValue = Number(
      sessionStorage.getItem(STORAGE_KEY)
    );

    if (
      Number.isFinite(storedValue) &&
      storedValue > Date.now()
    ) {
      return storedValue;
    }

    return null;
  }

  function startNewTimer() {
    timerEnd =
      Date.now() + TIMER_DURATION_SECONDS * 1000;

    sessionStorage.setItem(
      STORAGE_KEY,
      String(timerEnd)
    );
  }

  function resetTimer() {
    timerEnd = null;
    sessionStorage.removeItem(STORAGE_KEY);

    const timerElement =
      document.getElementById(TIMER_ID);

    if (timerElement) {
      timerElement.remove();
    }
  }

  function formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return (
      String(minutes).padStart(2, '0') +
      ':' +
      String(seconds).padStart(2, '0')
    );
  }

  function findCheckoutButton() {
    return document.querySelector(
      '#w4-storefront-drawer .wizz-checkout-button'
    );
  }

  function createTimerElement() {
    const timer = document.createElement('div');
    timer.id = TIMER_ID;

    timer.innerHTML = `
      <div class="elluxury-timer-row">
        <span class="elluxury-timer-label">
          Voltooi uw bestelling binnen
        </span>

        <span
          class="elluxury-timer-time"
          data-elluxury-cart-countdown
        >
          10:00
        </span>
      </div>
    `;

    return timer;
  }

  function ensureTimerExists() {
    if (!timerEnd) return null;

    const checkoutButton = findCheckoutButton();

    if (!checkoutButton) return null;

    let timer = document.getElementById(TIMER_ID);

    if (!timer) {
      timer = createTimerElement();

      checkoutButton.parentNode.insertBefore(
        timer,
        checkoutButton
      );
    }

    return timer;
  }

  function updateTimerDisplay() {
    if (!timerEnd) return;

    const timer = ensureTimerExists();

    if (!timer) return;

    const timeElement = timer.querySelector(
      '[data-elluxury-cart-countdown]'
    );

    if (!timeElement) return;

    let secondsLeft = Math.ceil(
      (timerEnd - Date.now()) / 1000
    );

    if (secondsLeft <= 0) {
      startNewTimer();
      secondsLeft = TIMER_DURATION_SECONDS;
    }

    timeElement.textContent = formatTime(secondsLeft);

    timeElement.classList.toggle(
      'is-urgent',
      secondsLeft <= 3 * 60
    );

    timeElement.classList.toggle(
      'is-critical',
      secondsLeft <= 60
    );
  }

  async function checkCartState() {
    if (cartRequestRunning) return;

    cartRequestRunning = true;

    try {
      const root =
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      const response = await fetch(
        root + 'cart.js',
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          cache: 'no-store'
        }
      );

      if (!response.ok) {
        throw new Error(
          'Winkelwagen kon niet worden gecontroleerd.'
        );
      }

      const cart = await response.json();
      const itemCount = Number(cart.item_count) || 0;

      if (itemCount === 0) {
        resetTimer();
      } else {
        /*
          Start een nieuwe timer wanneer:
          1. de winkelwagen eerst leeg was;
          2. er nog geen geldige timer bestaat.
        */
        if (previousItemCount === 0) {
          startNewTimer();
        } else if (!timerEnd) {
          timerEnd = getStoredTimerEnd();

          if (!timerEnd) {
            startNewTimer();
          }
        }

        ensureTimerExists();
        updateTimerDisplay();
      }

      previousItemCount = itemCount;
    } catch (error) {
      /*
        Bij een tijdelijke fout blijft de bestaande timer werken.
        De webshop wordt hierdoor niet onderbroken.
      */
      if (timerEnd) {
        ensureTimerExists();
        updateTimerDisplay();
      }
    } finally {
      cartRequestRunning = false;
    }
  }

  function initialize() {
    addStyles();

    timerEnd = getStoredTimerEnd();

    /*
      Controleert onmiddellijk de winkelwagen.
    */
    checkCartState();

    /*
      Werkt alleen de zichtbare tijd bij.
      Dit veroorzaakt geen netwerkverzoek.
    */
    window.setInterval(
      updateTimerDisplay,
      1000
    );

    /*
      Controleert iedere 4 seconden of de winkelwagen
      leeg of opnieuw gevuld is.
    */
    window.setInterval(
      checkCartState,
      4000
    );

    /*
      Extra controle wanneer de klant terugkeert
      naar het browsertabblad.
    */
    document.addEventListener(
      'visibilitychange',
      function () {
        if (!document.hidden) {
          checkCartState();
        }
      }
    );

    /*
      Extra snelle controle na klikken in de Snap Drawer,
      bijvoorbeeld na verwijderen of toevoegen.
    */
    document.addEventListener(
      'click',
      function (event) {
        if (
          event.target.closest(
            '#w4-storefront-drawer'
          )
        ) {
          window.setTimeout(
            checkCartState,
            700
          );
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();